import React, { useRef } from 'react';
import { Button, Modal, connectModal } from '@gsa/afp-component-library';
import { z } from 'zod';
import { FormGenerator } from '@gsa/afp-shared-form-utils';
import { FUNDING_STATUS } from '../../utils/additional-utils';

const ConfirmFundingModal = ({
  handleCancel,
  selectedRows,
  selectedFunding,
  handleContinue,
}) => {
  const formRef = useRef(null);
  const schema = z.object({
    reason: z.coerce.string().refine((value) => value !== '-1', {
      message: 'Please select reason',
    }),
  });

  const options = [
    {
      label: '-Select-',
      value: '-1',
    },
    {
      label: 'Additional type not approved for funding',
      value: 'Additional type not approved for funding',
    },
    {
      label: 'Agency not approved for additional vehicles',
      value: 'Agency not approved for additional vehicles',
    },

    {
      label: 'BOAC has delinquencies over 90 days',
      value: 'BOAC has delinquencies over 90 days',
    },

    {
      label: 'Funding unavailable',
      value: 'Funding unavailable',
    },

    {
      label: 'Other',
      value: 'Other',
    },

    {
      label: 'Returned due to order not created',
      value: 'Returned due to order not created',
    },

    {
      label: 'Returned for funding review (new FY)',
      value: 'Returned for funding review (new FY)',
    },

    {
      label: 'SIN not available',
      value: 'SIN not available',
    },
  ];

  const content = {
    buttonControls: { submit: false, cancel: false },
    sections: [
      {
        fields: [
          {
            id: 'reason',
            label: 'Provide reason',
            type: 'select',
            required: true,
            options: options,
          },
        ],
      },
    ],
  };

  const getTextFromStatus = () => {
    if (selectedFunding === FUNDING_STATUS.NOT_FUNDED) {
      return 'not funded';
    }

    if (selectedFunding === FUNDING_STATUS.RESCIND_FUNDING) {
      return 'rescind funding';
    }
    return 'funded';
  };

  const getTitleFromStatus = () => {
    if (selectedFunding === FUNDING_STATUS.NOT_FUNDED) {
      return 'Mark records as not funded';
    }

    if (selectedFunding === FUNDING_STATUS.RESCIND_FUNDING) {
      return 'Rescind funding on selected record';
    }
    return 'Mark record as funded';
  };

  return (
    <Modal
      onClose={handleCancel}
      actions={
        <>
          <Button
            type="button"
            variant="unstyled"
            onClick={handleCancel}
            label="Cancel"
            className="padding-right-2"
          />
          <Button
            type={selectedFunding === FUNDING_STATUS.FUNDED ? 'button' : 'submit'}
            variant="primary"
            onClick={() => {
                if(selectedFunding !== FUNDING_STATUS.FUNDED){
                    formRef.current.submit();
                }else{
                    handleContinue(null);
                }
              }}
            leftIcon={{ name: 'check' }}
            label={'Confirm'}
            form="funding-modal"
          />
        </>
      }
    >
      <h2 className="font-body-md">{getTitleFromStatus()}</h2>

      <div className="margin-top-2 padding-2 bg-primary-lightest padding">
        You selected <strong>{selectedRows?.length} requests</strong> to mark {getTextFromStatus()}.
      </div>

      {selectedFunding !== 'FUNDED' && (
        <FormGenerator
          ref={formRef}
          className="margin-top-2"
          id="funding-modal"
          schema={schema}
          content={content}
          onSubmit={(data) => handleContinue(data)}
        />
      )}
    </Modal>
  );
};

export default connectModal(ConfirmFundingModal);
